import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
  PasswordInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { iotconnectorstext } from "variables/MBM/iotconnectors";
import { serverTypeData } from "variables/MBM/lists/iotconnectors";
import { postMBMIotConnector, putMBMIotConnector } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { ftpprotocoleData } from "variables/MBM/lists/iotconnectors";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function IoTConnectorDialog(props) {
  const { closeModal, refetch, currentConnector } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [name, setName] = useState(currentConnector?.name || "");
  const [servertype, setServertype] = useState(currentConnector?.servertype || "");
  const [organizationid, setOrganizationid] = useState(currentConnector?.connectionproperties?.organizationid || "");
  const [dirpath, setDirpath] = useState(currentConnector?.connectionproperties?.dirpath || "");
  const [filesregex, setFilesregex] = useState(currentConnector?.connectionproperties?.filesregex || "");
  const [username, setUsername] = useState(currentConnector?.connectionproperties?.username || "");
  const [password, setPassword] = useState(currentConnector?.connectionproperties?.password || "");
  const [ipaddress, setIpaddress] = useState(currentConnector?.connectionproperties?.ipaddress || "");
  const [port, setPort] = useState(currentConnector?.connectionproperties?.port || "");
  const [protocole, setProtocole] = useState(currentConnector?.connectionproperties?.protocole || "");
  const [prefix, setPrefix] = useState(currentConnector?.connectionproperties?.prefix || "");

  const [groups, setGroups] = useState(currentConnector?.groupid ? "" + currentConnector.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      name.length > 0 &&
      servertype.length > 0 &&
      groups.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups, servertype]);


  const handleSubmit = async (event) => {
    if (currentConnector)
      updateIotconnector(event);
    else
      createIotconnector(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleServertypeChange = (event) => { setServertype(event.target.value); };
  const handleOrganizationidChange = (event) => { setOrganizationid(event.target.value); };
  const handleDirpathChange = (event) => { setDirpath(event.target.value); };
  const handleFilesregexChange = (event) => { setFilesregex(event.target.value); };
  const handleUsernameChange = (event) => { setUsername(event.target.value); };
  const handlePasswordChange = (event) => { setPassword(event.target.value); };
  const handleIpaddressChange = (event) => { setIpaddress(event.target.value); };
  const handlePortChange = (event) => { setPort(event.target.value); };
  const handleProtocoleChange = (event) => { setProtocole(event.target.value); };
  const handlePrefixChange = (event) => { setPrefix(event.target.value); };

  const createIotconnector = async (event) => {
    let connectionproperties = {};
    if (servertype === 'ftpserver') {
      connectionproperties.dirpath = dirpath;
      connectionproperties.filesregex = filesregex;
      connectionproperties.username = username;
      connectionproperties.password = password;
      connectionproperties.ipaddress = ipaddress;
      connectionproperties.port = port;
      connectionproperties.protocole = protocole;
      connectionproperties.prefix = prefix;
    }
    else {
      connectionproperties.organizationid = organizationid;
    }


    await axios
      .post(
        postMBMIotConnector(),
        {

          groups,
          servertype,
          name,
          connectionproperties,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Connecteur créée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const updateIotconnector = async (event) => {
    let connectionproperties = { ...currentConnector.connectionproperties };
    if (servertype === 'ftpserver') {
      connectionproperties.dirpath = dirpath;
      connectionproperties.filesregex = filesregex;
      connectionproperties.username = username;
      connectionproperties.password = password;
      connectionproperties.ipaddress = ipaddress;
      connectionproperties.port = port;
      connectionproperties.protocole = protocole;
      connectionproperties.prefix = prefix;
    }
    else {
      connectionproperties.organizationid = organizationid;
    }
    await axios
      .put(
        putMBMIotConnector(currentConnector.id),
        {
          name,
          connectionproperties,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Connecteur modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={currentConnector ? 12 : 6} md={currentConnector ? 12 : 7} lg={currentConnector ? 12 : 7}>
            <div>
              <TextInput
                isRequired
                inputTitle={iotconnectorstext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={iotconnectorstext.servertype}
                selectValue={servertype}
                handleSelectValueChange={handleServertypeChange}
                data={serverTypeData}
                disabled={currentConnector}
              />
            </div>
            {servertype === 'ftpserver' ?
              <>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.ipaddress}
                    textInput={ipaddress}
                    handleTextInputChange={handleIpaddressChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.port}
                    textInput={port}
                    handleTextInputChange={handlePortChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.username}
                    textInput={username}
                    handleTextInputChange={handleUsernameChange}
                  />
                </div>
                <div>
                  <PasswordInput
                    inputTitle={iotconnectorstext.password}
                    textInput={password}
                    handleTextInputChange={handlePasswordChange}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={iotconnectorstext.protocole}
                    selectValue={protocole}
                    handleSelectValueChange={handleProtocoleChange}
                    data={ftpprotocoleData}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.dirpath}
                    textInput={dirpath}
                    handleTextInputChange={handleDirpathChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.filesregex}
                    textInput={filesregex}
                    handleTextInputChange={handleFilesregexChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={iotconnectorstext.prefix}
                    textInput={prefix}
                    handleTextInputChange={handlePrefixChange}
                  />
                </div>
              </>
              :
              <div>
                <TextInput
                  inputTitle={iotconnectorstext.organizationid}
                  textInput={organizationid}
                  handleTextInputChange={handleOrganizationidChange}
                />
              </div>
            }

          </GridItem>
          {currentConnector ?
            <></> :
            <GridItem xs={12} sm={6} md={5} lg={5}>
              <div className={classes.treeVisible}>
                <TreeLabel>Choix du périmètre</TreeLabel>
                <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                  <EmbeddedEntitesTree
                    selectedIds={setGroups}
                    userSelectedIds={groups}
                  />
                </ImageList>
              </div>
            </GridItem>
          }
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentConnector ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default IoTConnectorDialog;
